import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Route } from 'react-router-dom';

import { NoDogfoodingWarning } from '../../components/NoDogfoodingWarning';
import { TrackedRoutes } from '../../components/TrackedRoutes';

import { ConnectionDetail, ConnectionList } from './components';

/**
 * The baseline title sits here rather than on each screen, so it also covers
 * the detail screen's not-found, error and too-many-users states. Without a
 * title of its own the tab keeps whichever page was open last.
 */
export const SsoPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>SSO - Choco Admin</title>
      </Helmet>
      <NoDogfoodingWarning subject="SSO" />
      <TrackedRoutes>
        <Route index element={<ConnectionList />} />
        <Route path=":connectionId" element={<ConnectionDetail />} />
      </TrackedRoutes>
    </>
  );
};
